export default __webpack_public_path__ + "static/media/myaccount.100a31c0.svg";